import React from "react";
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import {
    Container,
    Header,
    Image,

} from "semantic-ui-react";
import DesignerImage from '../../images/grafix-banner/gfx-vault.svg';
import { Link } from 'react-router-dom';


class NotFound extends React.Component {
    componentDidMount() {
        dispatch.app.baseModuleType("Account")
    }
    render() {

        return (
            <Container fluid className="pad_40">
                <Header as='h2' className='text-muted' icon textAlign='center' >Access Denied!</Header>
                <Image style={{ 'height': '300px' }} src={DesignerImage} className="landingImage" size='large' centered={true} />
                <Header as='h5' className='text-muted' icon textAlign='center'>You do not have authorization to view this page.<br /> If you accidentaly came here, go back <Link to={`/app/${this.props.selectedAccount._id}/dashboard`}>Dashboard</Link></Header>
            </Container>
        );
    }
}
function mapStateToProps(state) {

    return {
        selectedAccount: state.app.selectedAccount,
    };
}

const connectedNotFound = connect(mapStateToProps)(NotFound);
export default connectedNotFound
